import ReactDOM from 'react-dom';
import { escapeHtml } from 'sma.common/utils';

const Class = require('sma.fs/chide/class');
const chide = require('sma.fs/chide/ui');
const Fields = require('sma.fs/surveys/fields');
const PageStatus = require('sma.fs/surveys/editor/page-status.coffee');
const AdvancedBranching = require('sma.fs/surveys/editor/branching.coffee');
const modals = require('sma.common/components/modals');
const Dropdown = require('sma.admin/components/dropdowns/dropdown');

const { Looping, Branching } = require('sma.fs/surveys/advanced');
const { randomString } = require('sma.common/utils');
const Callout = require('sma.common/components/callout').default;

// TODO: make params to Editor
const EDIT_URL = '.';
const ALLOW_SAVE = true;

const hashCode = function (str) {
	let hash = 0;
	let i;
	let char;

	if (str.length === 0) {
		return hash;
	}
	for (let _i = 0; _i < str.length; _i++) {
		char = str.charCodeAt(i);
		hash = (hash << 5) - hash + char;
		hash &= hash; // Convert to 32bit integer
	}
	return hash;
};

const truncate = function (val, limit) {
	if (val.length > limit) {
		const tokens = val.split(' ');
		let newString = '';
		while (newString.length + tokens[0].length < limit) {
			newString += `${tokens.shift()} `;
		}
		if (newString.length === 0)
			newString = tokens[0].substring(0, limit - 3);
		return `${newString}...`;
	}
	return val;
};

const Page = $.klass({
	placeholder: `<li class="placeholder">${gettext('You haven\'t added any questions yet. To get started, drag a question from the left panel onto this area.')} </li>`,
	visible: false,
	rendered: false,

	options: {
		label: Class.create(chide.opts.Text, {
			inputClass: 'text short',
			help: gettext(
				'About Page Labels - Page labels allow you to create named pages of your survey that can then be branched to.',
			),
			label: gettext('Page Label'),
			display(justIndex) {
				return this.get()
					? this.get()
					: justIndex
						? this.page.index + 1
						: `${gettext('Page')} ${this.page.index + 1}`;
			},
			changed(_value) {
				this.page.element.trigger('pageLabelChanged', [this.page, this]);
			},
		}),

		randomize: Class.create(chide.opts.Checkbox, {
			label: gettext('Randomize questions on this page'),
			help: gettext(
				'About Randomize - Check this option if you would like the questions on this page to be shown in a random order every time this survey is taken.',
			),
			enabled: true,
		}),
	},

	initialize(config) {
		this.id = randomString(10);
		this.fields = [];
		$.extend(this, config);

		this.editor = this.survey.editor;

		this.randomize = new this.options.randomize({ value: this.info === undefined ? false : !!this.info.randomize });

		this.label = new this.options.label({
			page: this,
			value: config.info && config.info.label ? config.info.label : undefined,
		});

		if (this.element) {
			this.element.html(this.placeholder);
		}

		if (this.info && this.info.children.length) {
			for (let j = 0; j < this.info.children.length; j++) {
				this.addField(undefined, this.info.children[j]);
			}
		}
	},

	renderOptions() {
		return $('<div></div>', { class: 'option-group' }).append(
			this.label.render(),
			this.randomize.render(),
		);
	},

	render() {
		if (!this.rendered) {
			$.each(this.fields, function () {
				this.render();
			});
			this.rendered = true;
		}

		this.bind('fieldRemoved', this.fieldRemoved);
		this.survey.resizeSideBySide();
		this.survey.renderVideoElements();
	},

	isBranched() {
		if (this.branching && this.branching.length) {
			return true;
		}

		let result = false;

		$.each(this.fields, function () {
			if (this.choices && this.choices.value) {
				$.each(this.choices.value, function () {
					if (this.branching && this.branching.value) {
						result = true;
					} else if (this.field && this.field.branchingOptions) {
						$.each(this.field.branchingOptions, function () {
							if (this.value && this.value !== '-1') {
								result = true;
							}
						});
					}
				});
			}
		});

		return result;
	},

	isLooped() {
		return this.survey.looping.pageIsLooped(this);
	},

	removeField(field, remove, fade) {
		const index = this.fields.indexOf(field);
		this.fields.splice(index, 1);

		if (remove === undefined ? true : remove) {
			this.survey.removeBranchingRulesWithVariable(field.id);
			field.removed = true;
			if (fade !== false) {
				field.element.fadeOut(500, function () {
					$(this).remove();
				});
			} else {
				field.element.remove();
			}
		}
		this.trigger('fieldRemoved', {
			survey: this.survey,
			field,
		});
	},

	addExistingField(field, pos) {
		let before;

		field.page = this;

		try {
			if (typeof pos === 'undefined' || pos === undefined) {
				before = undefined;
			} else if (typeof pos === 'number' && pos >= -1) {
				before = this.fields[pos < 0 ? 0 : pos];
			} else if (pos.element !== undefined) {
				before = pos;
			} else {
				before = $(pos).firstAttached(Fields.Field);
			}
		} catch (ex) {
			before = undefined;
		}

		if (before !== undefined) {
			if (pos < 0) {
				this.fields.splice(0, 0, field);
				field.element.insertBefore(before.element);
			} else {
				field.element.insertAfter(before.element);
				this.fields.splice(this.fields.indexOf(before) + 1, 0, field);
			}
		} else {
			field.element
				.appendTo(this.element)
				.css('display', 'none')
				.fadeIn(500);

			this.fields.push(field);
		}

		if (this.visible) {
			field.render();
			// Fix cursor for chrome
			field.element[0].onselectstart = function () {
				return false;
			};
		}
	},

	buildField(type, info) {
		return $('<li class="field"></li>')
			.attr('name', type.qlass)
			.attachAndReturn(type.constructor, info, this.editor)[0];
	},

	addField(type, info, pos, _bank) {
		// no type specified, find the type from the info
		if (type === undefined && info !== undefined) {
			if (info.idname === undefined) {
				/*
				YOU SHOULD NOT HAVE TO ADD NEW QUESTION TYPES TO THIS SECTION
				ANYMORE IT IS HERE FOR BACKWARDS COMPATABILITY
				*/
				if (info.grouped === true) {
					if (
						info.children
						&& info.children[0]
						&& info.children[0].name
						&& info.children[0].name.split('_')[
							info.children[0].name.split('_').length - 1
						] === '0'
					) {
						info.children[0].name = info.children[0].name.substring(
							0,
							info.children[0].name.length - 2,
						);
					}

					if (info.custom == true) {
						type = Fields.Natrix.prototype;
						if (info.threed == true) {
							type = Fields.ThreeDGridField;
						}
					} else if (info.children[0].type == 'string') {
						type = Fields.TextGridField;
					} else if (info.children[0].type == 'dropdown') {
						type = Fields.DropDownGridField;
					} else if (info.children[0].type == 'multiple') {
						type = Fields.MultipleChoiceGridField;
					}
				} else if (info.children.length === 0) {
					type = Fields.SectionField;
				} else if (info.children[0].type == 'datetime') {
					type = Fields.DateTimeField;
				} else if (info.children[0].type == 'string') {
					type = Fields.TextField;
				} else if (info.children[0].type == 'single') {
					type = Fields.SingleChoiceField;
				} else if (info.children[0].type == 'dropdown') {
					type = Fields.DropDownChoiceField;
				} else if (info.children[0].type == 'multiple') {
					type = Fields.MultipleChoiceField;
				}
			} else {
				type = info.idname;
			}
		}

		if (typeof type === 'string') {
			// it's a name, lookup type in the type mapping
			type = this.survey.fieldTypes[type];
		} else if (typeof type === 'function') {
			// it's a constructor, get the prototype
			type = type.prototype;
		}

		// bad or unknown field type
		if (type === undefined || type.qlass === undefined) {
			return;
		}

		const field = this.buildField(type, info);

		this.addExistingField(field, pos);

		if (this.visible) {
			this.rendered = true;
		}

		this.survey.resizeSideBySide();

		return field;
	},

	fieldRemoved(event, info) {
		info.survey._formatInfo = null;
		info.survey.editor.pageStatusView.render();
		info.survey.editor.toolbox.css('margin-top', 0);
	},

	formatInfo() {
		const questions = [];

		$('li.field', this.element).each(function (_j) {
			questions.push($(this).firstAttached(Fields.Field).id);
		});

		return {
			page: this.label.display(),
			index: this.index,
			id: this.id,
			questions,
		};
	},

	/// Shows the advanced branching wizard dialog for this page.
	showBranchingWizard() {
		const that = this;

		// force-regenerate the survey info
		this.survey._formatInfo = null;

		const wizard = new AdvancedBranching({
			survey: this.survey,
			branching: this.branching,
			page: this,
			callback(branching, _otherwise) {
				that.branching = branching;

				that.survey.editor.pageStatusView.render();

				$('#survey-editor-page-options')
					.empty()
					.append(
						that.renderOptions().attr('id', 'survey-editor-page-options'),
					);
			},
		});

		wizard.show();
	},

	renderBranchingSelect() {
		const choices = [];

		$.each(this.survey.pages.slice(this.index + 1), function (_i) {
			choices.push([
				this.id,
				this.label.get() || `${gettext('Page')} ${this.index + 1}`,
			]);
		});

		return chide.opts.renderSelect(choices, '---');
	},

	getBranchingSelect() {
		return (
			this._branchingSelect
			|| (this._branchingSelect = this.renderBranchingSelect())
		).clone();
	},
});

const Survey = $.klass({
	defaults: {
		title: gettext('Title'),
		description: '',
	},

	fieldTypes: undefined,

	renderVideoElements() {
		setTimeout(() => {
			$('.form-video-element').each(function () {
				const that = $(this);
				const regex = /\{\{\s*(\w+):([\w\-]+):(\d+):(\d+)\s*\}\}/;
				const main_element = that.parent().parent();
				if (main_element.parent().hasClass('fr-element')) {
					return;
				}
				const iframe = main_element.find('iframe');
				if (iframe.length > 0) {
					return;
				}

				// Extract matches
				const matches = that.text().match(regex);
				if (matches) {
					const platform = matches[1];
					const id = matches[2];
					const width = matches[3];
					const height = matches[4];
					let video_url = `https://www.youtube.com/embed/${id}`;

					if (platform === 'Vimeo') {
						video_url = `https://player.vimeo.com/video/${id}`;
					}
					main_element.append(`<iframe frameborder="0" width="${width}" height="${height}" src="${video_url}" referrerpolicy="origin"></iframe>`);
				}
			});
		}, 50);
	},

	stripScriptTags(val) {
		val = val
			.replace(/<script[\s>]/gi, '<!--<script')
			.replace(/<\/script>/gi, '</script>-->')
			.replace(/<iframe[\s>][^]*?<\/iframe>/gi, '')
			.replace(/<iframe[\s>][^]*?$/gi, '')
			.replace(/<object[\s>][^]*?<\/object>/gi, '')
			.replace(/<embed[\s>][^]*?>/gi, '');
		val = val.replace(/<img([^>]*)\sonerror\s*=\s*(['"]?).*?\2([^>]*)>/gi, '<img$1$3>');
		this.renderVideoElements();
		return val;
	},

	initialize(config) {
		$.extend(this, config);

		const that = this;

		this.title = new (Class.create(chide.opts.Text, {
			changed(val) {
				let safe = _.escape(val);
				console.log('changed title', val, safe);
				safe = truncate(safe, 50);
				$('.sma-js-form-title').html(safe);
			},
		}))({ value: this.defaults.title });

		this.description = new (Class.create(chide.opts.Html, {
			changed(val) {
				$('.sma-js-form-description').html(that.stripScriptTags(val));
			},
		}))({ value: this.defaults.description });

		this.looping = new Looping(this);

		this.pages = [];
		this.currentPage = undefined;
		this.questions = {};
		this.nameMapping = {};
		this.pageMapping = {};

		this._refreshPages();
	},

	_refreshPages() {
		const that = this;

		this._formatInfo = undefined;

		this.pageMapping = {};

		const refresh = function () {
			$('a.page-button').text((i) => that.pages[i].label.display(true));
			try {
				$('.page-buttons').sortable('refresh');
			} catch (e) {
				// eslint-disable-line
			}
		};

		for (let i = 0; i < this.pages.length; i++) {
			this.pages[i].index = i;
			this.pageMapping[this.pages[i].id] = this.pages[i];
		}

		// HACK
		Fields.Helpers.mapping = this.pageMapping;

		this.questions = {};

		for (let i = 0; i < this.pages.length; i++) {
			$.each(this.pages[i].fields, function () {
				that.questions[this.id] = this;
				if (this.hasChoiceBranching) {
					if (!Branching.Simple.prototype.isValid(this)) {
						alert(
							$.format(
								gettext(
									'Please note that skipping on page {0} has been removed due to this change.',
								),
								[i + 1],
							),
						);
						Branching.Simple.prototype.reset(this);
					}
				}
			});
		}

		this.looping.checkLoops();
		refresh();
	},

	removeBranchingConditionWithVariable(condition, variableId) {
		const that = this;

		if (condition.items === undefined) { // normal condition
			if (variableId === condition.variable) {
				return null;
			}
		} else { // sub conditions
			const someInvalidCondition = condition.items.filter((subcondition) => that.removeBranchingConditionWithVariable(subcondition, variableId) === null);

			if (someInvalidCondition.length !== 0) {
				return null; // if any condition is invalid, remove the rule or condition (the parent)
			}
		}

		return condition;
	},

	removeBranchingRulesWithVariable(variableId) {
		const that = this;

		$.each(this.pages, function (_p) {
			if (this.branching) {
				this.branching = this.branching.map((rule) => {
					rule.condition = that.removeBranchingConditionWithVariable(rule.condition, variableId);
					return rule;
				}).filter((rule) => rule.condition !== null);
			}
		});
	},

	getBranchTargets(fromPage) {
		if (fromPage == undefined) {
			fromPage = this.currentPage;
		}

		const index = this.pages.indexOf(this.currentPage);

		return this.pages.slice(index + 1);
	},

	getPageById(id) {
		return this.pageMapping[id];
	},

	getFieldCount() {
		let total = 0;
		$.each(this.pages, function () {
			total += this.fields.length;
		});
		return total;
	},

	getFieldArray(fields, page) {
		page = page === undefined ? this.currentPage : page;

		return $.map($.makeArray(fields), (el) => {
			try {
				if (typeof el === 'number' && el >= 0) {
					return page.fields[el];
				}
				if (el instanceof Fields.Field) {
					return el;
				}
				return $(el).firstAttached(Fields.Field);
			} catch (ex) {
				return null;
			}
		});
	},

	getAllFields() {
		const result = [];
		$.each(this.pages, (i, page) => {
			$.each(page.fields, (i, field) => {
				result.push(field);
			});
		});
		return result;
	},

	getTarget(target, info) {
		const rowRe = /^([-a-zA-Z0-9]+)\[(.+?):\]$/;
		const colRe = /^([-a-zA-Z0-9]+)\[:(.+?)\]$/;

		const row = rowRe.exec(target);
		try {
			if (row != null) {
				return {
					id: target,
					label: info.questions[row[1]].rows[row[2]].label,
				};
			}

			const col = colRe.exec(target);
			if (col != null) {
				return {
					id: target,
					label: info.questions[col[1]].types[col[2]].label,
				};
			}

			if (info.variables[target]) {
				return {
					id: target,
					label: info.variables[target].label,
				};
			}

			if (info.questions[target]) {
				return {
					id: target,
					label: info.questions[target].label,
				};
			}

			if (this.nameMapping[target]) {
				return {
					id: this.nameMapping[target].id,
					label: info.questions[this.nameMapping[target].id].label,
				};
			}
		} catch (e) {
			return {
				id: '-',
				label: 'INVALID',
			};
		}

		return {
			id: '-',
			label: 'INVALID',
		};
	},

	removePage(i) {
		const that = this;

		if (i === undefined) {
			i = this.pages.indexOf(this.currentPage);
		}

		if (this.pages.length <= 1) {
			return false;
		}

		new modals.CheckboxModal(
			gettext('Delete page'),
			gettext(
				'Deleting this page from this form will also delete any associated data that has been collected from users of this form.',
			),
			gettext(
				'Yes, I understand that upon saving this form the questions within this page and any associated data will be permanently deleted and that this action cannot be undone.',
			),
			() => {
				const page = this.pages[i];

				this.trigger('fieldsRemoved', { fields: page.fields });

				this.trigger('pageRemoved', {
					page,
					index: i,
				});

				// TODO: make this bind instead of calling
				this.looping.pageRemoved({
					page,
					index: i,
				});

				$.each(page.fields, function () {
					const name = this.name.get();

					if (name !== undefined && that.nameMapping[name]) {
						delete that.nameMapping[name];
					}
				});

				page.element.remove();

				this.pages.splice(i, 1);

				this._refreshPages();

				if (page === this.currentPage) {
					this.switchPage(i >= this.pages.length ? this.pages.length - 1 : i);
				}

				this.trigger('afterPageRemoved', {
					page,
					index: i,
				});
			},
			{
				destroyOnClose: true,
				contingent: true,
				isDelete: true,
			},
		);
	},

	removeFields(fields) {
		fields = this.getFieldArray(fields);

		this.trigger('fieldsRemoved', { fields });
		for (let i = 0; i < fields.length; i++) {
			fields[i].page.removeField(fields[i]);
			this.looping.fieldRemoved(fields[i].id);
			if (fields[i].name.value in this.nameMapping) {
				delete this.nameMapping[fields[i].name.value];
			}
		}
	},

	moveFields(fields, page) {
		fields = this.getFieldArray(fields);

		for (let i = 0; i < fields.length; i++) {
			fields[i].page.removeField(fields[i], false);
			page.addExistingField(fields[i]);
		}
	},

	movePage(oldPos, newPos) {
		if (oldPos != newPos) {
			$('> .page', this.element)
				.eq(oldPos)[oldPos > newPos ? 'insertBefore' : 'insertAfter'](
					$('> .page', this.element).eq(newPos),
				);

			const removed = this.pages.splice(oldPos, 1)[0];
			this.pages.splice(newPos, 0, removed);

			this._refreshPages();

			this.switchPage(newPos, true);
		}
	},

	switchPage(i, pageMove) {
		const oldPage = this.currentPage;

		if (oldPage !== undefined) {
			oldPage.visible = false;
		}

		this.currentPage = this.pages[i];
		this.currentPage.visible = true;

		$('> .page', this.element).removeClass('active');
		this.currentPage.element.addClass('active');
		this.currentPage.render();

		this.trigger('pageSwitched', {
			page: this.currentPage,
			index: i,
			pageMove: !!pageMove,
		});
	},

	addEmptyPage(index) {
		if (index === undefined) {
			index = this.pages.indexOf(this.currentPage);
			if (index === -1) {
				index = undefined;
			} else {
				index += 1;
			}
		}
		return this.addPage(undefined, index, true);
	},

	beforeAddPage() {
		return true;
	},

	addPage(info, index, show) {
		if (show && this.element.triggerHandler('beforeAddPage', {}) === false) {
			return false;
		}

		const page = $('<ol class="page"></ol>').attachAndReturn(Page, {
			survey: this,
			info,
			// when loading pages, use the index as the page ID to avoid hacks for branching
			id: info !== undefined ? this.pages.length.toString() : undefined,
			visible: !!show,
		})[0];

		if (index === undefined || index >= this.pages.length) {
			index = undefined;
			this.element.append(page.element);
			this.pages.push(page);
		} else {
			page.element.insertBefore($('ol.page', this.element).eq(index));
			this.pages.splice(index, 0, page);
		}

		this._refreshPages();

		this.trigger('pageAdded', {
			page,
			index,
			show,
		});

		if (show) {
			this.switchPage(page.index);
		}

		return page;
	},

	formatInfo() {
		if (!this._formatInfo) {
			const pages = [];
			const pageMapping = {};
			const metas = [
				'_ip_address',
				'_locale',
				'_language',
				'_invite_email',
				'_weighted_score',
			];
			const questions = {};
			const languages = {};

			_.each(this.editor.languages.list, (el) => {
				languages[el.code] = el.name;
			});

			const variables = {};
			const namedVars = {};

			$.each(this.pages, (i, el) => {
				pages.push((pageMapping[el.id] = el.formatInfo()));
				$.each(el.fields, (i, el) => {
					const q = el;
					questions[el.id] = el.formatInfo();
					$.each(el.getVariables(), (i, el) => {
						variables[el.id] = el.serialize();
						if (q.name.get()) {
							namedVars[q.name.get()] = namedVars[`${q.name.get()}_${i}`] = variables[el.id];
						}
					});
				});
			});

			this._formatInfo = {
				pages,
				pageMapping,
				questions,
				variables,
				namedVars,
				metas,
				resolveVariable(name) {
					if (name in namedVars) {
						return namedVars[name];
					}
					if (/^_cv_/.test(name)) {
						return {
							id: name,
							label: `Collector variable [${name.substring(4)}]`,
							type: 'string',
						};
					}
					if (/^_gv_/.test(name)) {
						return {
							id: name,
							label: `GET variable [${name.substring(4)}]`,
							type: 'string',
						};
					}
					if (name in variables) {
						return variables[name];
					}
					return null;
				},
			};
		}

		return this._formatInfo;
	},

	load(info) {
		this.title.set(info.title);
		this.description.set(info.description);

		this.render();

		if (!info.form) {
			this.addEmptyPage();
			return;
		}

		for (let i = 0; i < info.form.length; i++) {
			this.addPage(info.form[i], undefined, false);
		}

		/* update branching rules to use page IDs */
		$.each(this.pages, function () {
			const page = this;

			if (page.info.branching) {
				page.branching = page.info.branching;
			}

			$.each(page.fields, function () {
				Fields.Helpers.normalizeField(this);
			});
		});

		this.resizeSideBySide();
	},

	serialize() {
		const that = this;
		const pages = [];

		_.each(this.pages, (el) => {
			const page = {
				type: 'page',
				children: [],
			};

			$('li.field', el.element).each(function () {
				page.children.push(
					$(this)
						.firstAttached(Fields.Field)
						.serialize(),
				);
			});

			if (el.randomize.get()) {
				page.randomize = true;
			}

			if (el.branching) {
				const rules = AdvancedBranching.updateRules(
					that.formatInfo(),
					el.branching,
				);

				page.branching = _.map(rules, (rule) => rule.serialize(that.formatInfo()));

				page.branching = AdvancedBranching.unserializePageIDs(
					that.formatInfo(),
					page.branching,
				);
			}

			if (el.label.value && el.label.get()) {
				page.label = el.label.value;
			}

			pages.push(page);
		});

		return {
			title: this.title.value,
			description: this.description.value,
			languages: this.editor.languages.list,
			languageDisplayStyle: this.editor.languages.displayStyle,
			form: pages,
		};
	},

	resizeSideBySide() {
		let max = 64;
		const group = $('.field-inline');

		$(group).each((x, el) => {
			if ($(el).height() > max) {
				max = $(el).height();
			}
		});

		$(group).height(max);
	},

	render() {
		const that = this;

		const descriptionSpan = $('<span class="sma-js-form-description"></span>')
			.html(this.stripScriptTags(this.description.get() || ''));

		$('> div.title', this.element)
			.empty()
			.append(
				$('<p class="description text-muted"></p>')
					.append(that.description.render())
					.append(
						`<a href="#" class="sma-js-form-description-edit sma-form-description-edit float-right">${
							gettext('Edit description')
						}<i class="nc-icon-mini ui-1_pencil ml-2"></i></a>\
			<a href="#" class="sma-js-form-description-edit-done btn btn-primary" style="display:none">${
	gettext('Done')
}</a>`,
					)
					.append(descriptionSpan),
			);

		// render() is called on every language switch, not just on initial load.
		// .delegate() accumulates handlers on the same element rather than replacing
		// them, so without this guard each language switch would add another set of
		// listeners — causing duplicate/delete/move to fire multiple times per click.
		// _fieldActionsBound ensures we register these handlers exactly once per
		// Survey instance regardless of how many times render() is invoked.
		if (!this._fieldActionsBound) {
			this._fieldActionsBound = true;

			this.element.delegate(
				'ol.page > li.field > div > a.remove',
				'click',
				function (e) {
					that.editor.removeField(
						$(this)
							.parents('.page')
							.find('li.field.active'),
						e,
					);
				},
			);

			this.element.delegate(
				'ol.page > li.field > div > a.duplicate',
				'click',
				function (e) {
					that.editor.duplicateField(
						$(this)
							.parents('.page')
							.find('li.field.active'),
						e,
					);
				},
			);

			this.element.delegate(
				'ol.page > li.field > div > a.move',
				'click',
				function (e) {
					that.editor.moveField(
						$(this)
							.parents('.page')
							.find('li.field.active'),
						e,
					);
				},
			);

			this.element.delegate(
				'ol.page > li.field > div > a.looping',
				'click',
				function (e) {
					that.editor.openLooping($(this).closest('li.field'), e);
				},
			);
		}

		$(this.title._input).hide();
		$(this.description._input).hide();
	},

	renderOptions() {
		const result = $('<div></div>').addClass('option-group');
		return result;
	},

	getPageDropdown(extra_choices, blankChoice, exclude_pages) {
		const choices = [];

		$.each(this.pages, (i, page) => {
			if (exclude_pages && exclude_pages.indexOf(i) > -1) {
				return true;
			}
			choices.push([i, page.label.display(false)]);
		});
		return chide.opts.renderSelect(
			$.merge(choices, extra_choices),
			blankChoice,
			false,
		);
	},
});

const Editor = $.klass({
	/* the content shown for field options when no field is selected */
	emptyFieldOptionContent: `<div class="alert alert-info no-options">${
		gettext('Please select a field on the right.')
	}</div>`,

	multipleFieldOptionContent: `<div class="alert alert-info">${
		gettext('You cannot change the properties on multiple fields at a time.')
	}</div>`,

	clipboardUrl: '',
	form_is_live: false,

	fieldTypes: (function () {
		const types = {};

		$.each(
			[
				'SectionField',
				'TextField',
				'TextGridField',
				'SingleChoiceField',
				'SingleChoiceGridField',
				'DropDownChoiceField',
				'DropDownGridField',
				'MultipleChoiceField',
				'MultipleChoiceGridField',
				'Natrix',
				'ThreeDGridField',
				'HiddenField',
				'NetPromoter',
				'DateTimeField',
				'DatasourceField',
				'DrillDownField',
				'RankingField',
				'FileField',
				'JavaScript',
				'Signature',
				'UploadField',
			],
			function () {
				types[Fields[this].prototype.qlass] = Fields[this].prototype;
			},
		);

		return types;
	}()),

	cleanItem(item) {
		const val = item.replace(/\n/g, ' ');
		return escapeHtml(val);
	},

	initialize(options) {
		// Need to clear existing instances of the Editor, the array can build up
		// if there's no page refresh while jumping between forms in the workflow.
		Fields.Field.instances = [];
		Editor.instances = [];

		const that = this;

		$.extend(this, options);

		if (options.isEligibilityForm) {
			window.smaPipingOptions = ['user', 'site', 'elig', 'applicant', 'submission'];
		}

		this.loader = new sma.components.Loader(this.element);

		if (options.hideBackButton !== undefined && options.hideBackButton) {
			this.backButton = '';
		} else {
			this.backButton = $('<a></a>', {
				href: options.backURL !== undefined ? options.backURL : '#',
				html: `<i class="nc-icon-mini arrows-1_minimal-left"></i><span class="sma-back-to-referrer">${gettext('Back')}</span>`,
				click(_e) {
					if (options.backURL) {
						return;
					}
					history.back();
					return false;
				},
			});
		}

		this.closeWindow = (options.closeWindow !== undefined) ? options.closeWindow : false;

		this.element.append(
			$('<div class="row sma-back-row"></div>').append(
				$('<div class="col-12"></div>').append(this.backButton),
			),
		);

		this.topRow = $('<div class="row"></div>');
		this.topRow.appendTo(this.element);

		this.initializeToolbox();

		this.pages = $(
			'<div class="pages"><div class="page-status"></div><div class="title"></div></div>',
		).click((e) => {
			if ($(e.target).is('a.remove')) {
				return false;
			}
			const chain = $(e.target)
				.parents('ol.page, li.field')
				.add(e.target);
			if (chain.filter('ol.page').length) {
				if (chain.filter('li.field').length) {
					this.fieldsSelected(chain.filter('li.field'), e);
				} else {
					this.fieldsSelected();
				}
			}
		});

		this.pages[0].onselectstart = function () {
			return false;
		};

		this.pages.prepend(
			$('<div class="float-sm-right"></div>')
				.append(this.previewButton)
				.append(this.topSaveButton),
		);

		this.initializeLanguages();

		chide.opts.Text.prototype.languages = this.languages;

		// TODO: this should come much earlier
		this.survey = this.pages.attachAndReturn(Survey, {
			editor: this,
			fieldTypes: this.fieldTypes,
		})[0];

		$(this.survey.element).bind({
			beforeRemovePage: $.proxy(this.beforeRemovePage, this),
			pageRemoved: $.proxy(this.pageRemoved, this),
			pageSwitched: $.proxy(this.pageSwitched, this),
			beforeAddPage: $.proxy(this.beforeAddPage, this),
		});

		this.pageStatusView = new PageStatus({
			survey: this.survey,
			el: this.pages.find('.page-status'),
		});

		if (ALLOW_SAVE) {
			this.showConfirmMessage = true;
			$(
				'.tools li.tool:not(.delete, .preview, .groups, .duplicate, .rename) a, .back-to-surveys, #view-options a',
			).mouseup(function (e) {
				/* Only do these for the left mouse button
				 * 0 - Left Button
				 * 1 - Middle Button
				 * 2 - Right Button
				 */
				if (e.button == 0) {
					const target = $(this);

					if (that.showConfirmMessage
						&& (!target.attr('target') || target.hasClass('preview-link'))) {
						e.preventDefault();
						window.onbeforeunload = () => {
						};

						that.save(() => {
							that.showConfirmMessage = false;
							if (target.attr('target') == '_blank') {
								window.open(target.attr('href'));
							} else {
								window.location = target.attr('href');
							}
						});
					}
				}
			});
		}

		$('.survey-tools li.tool.delete, .survey-tools li.tool.rename').click(
			() => {
				window.onbeforeunload = () => {
				};
			},
		);

		let isCtrl = false;
		$(document).keydown((e) => {
			if (e.which == 17) {
				isCtrl = true;
				setTimeout(() => {
					isCtrl = false;
				}, 2000);
				return;
			}
			if (e.which == 'S'.charCodeAt(0) && isCtrl) {
				// s
				that.save();
				e.preventDefault();
			}
		});
		$(document).keyup((e) => {
			if (e.which == 17) {
				setTimeout(() => {
					isCtrl = false;
				}, 0);
			}
		});

		this.keydownHotKeys = function (e) {
			if (
				$('ol.page.active li.field.active').length == 1
				&& $('ol.page.active li.field.active')
					.eq(0)
					.attr('name') == 'javascript'
			) {
				return;
			}
			if (e.which == 'A'.charCodeAt(0) && isCtrl) {
				// a
				e.preventDefault();
				that.fieldsSelected($('ol.page.active li.field'));
			} else if (e.which == 'D'.charCodeAt(0) && isCtrl) {
				// d
				e.preventDefault();
				const numberOfQuestions = $('ol.page li.field.active').length;

				if (numberOfQuestions > 0) {
					sma.components.Dialog.ConfirmDialog(
						gettext('Delete the selected questions?'),
						() => {
							const surv = Survey.instances[0];
							surv.removeFields($('ol.page li.field.active'));
							that.fieldsSelected();
						},
					);
				}
			} else if (e.which == 46) {
				// del
				if ($('ol.page li.field.active').length > 0) {
					e.preventDefault();
					sma.components.Dialog.ConfirmDialog(
						gettext('Delete the selected questions?'),
						() => {
							const surv = Survey.instances[0];
							surv.removeFields($('ol.page li.field.active'));
							that.fieldsSelected();
						},
					);
				}
			} else if (e.which == 34) {
				// Page Down
				e.preventDefault();
				const surv = Survey.instances[0];
				if (that.getPages().length - 1 == surv.currentPage.index) {
					return;
				}
				surv.switchPage(surv.currentPage.index + 1);
			} else if (e.which == 33) {
				// Page Up
				e.preventDefault();
				const surv = Survey.instances[0];
				if (surv.currentPage.index == 0) {
					return;
				}
				surv.switchPage(surv.currentPage.index - 1);
			} else if (e.which == 'C'.charCodeAt(0) && isCtrl) {
				// c
				if (!$('input[type=text]:focus, textarea:focus').length) {
					e.preventDefault();
					Fields.Actions.copy.handler.apply(this, [
						$('ol.page li.field.active'),
						null,
						null,
						false,
					]);
				}
			} else if (e.which == 'V'.charCodeAt(0) && isCtrl) {
				// v
				if (!$('input[type=text]:focus, textarea:focus').length) {
					e.preventDefault();
					Fields.Actions.paste.handler.apply(this, [
						$('ol.page li.field.active'),
						true,
					]);
				}
			}
		};

		this.load(() => {
			this.initializeLoaded();
			this.hashedJson = hashCode(this.serialize().survey);
		});

		$('[data-toggle="tooltip"]').tooltip();
	},

	initializeLoaded() {
		const that = this;

		this.viewport = $('<div class="viewport"></div>');

		this.previewButton = $('<a></a>', {
			html: gettext('Preview'),
			class: 'page-preview-link btn btn-default',
			id: 'sma-btn-preview',
			href: reverse('surveys-preview', { survey_id: this.surveyID }),
			click: (e) => {
				e.preventDefault();
				$.ajax({
					type: 'post',
					url: reverse('surveys-preview-save', { survey_id: this.surveyID }),
					data: { survey: this.serialize().survey },
					success: (_response) => {
						const redirectWindow = window.open(
							$(e.currentTarget).attr('href'),
							'_blank',
						);
					},
				});
			},
		});

		const surveyFullTitle = that.cleanItem(_.unescape(that.survey.title.get()));
		const surveyDisplayTitle = truncate(surveyFullTitle, 50);

		this.viewport
			.append(
				$('<div class="survey-top"></div>')
					.append(
						$('<div class="top-left">')
							.append(that.survey.title.render())
							.append(
								`<span class="sma-js-form-title" title="${surveyFullTitle}">${surveyDisplayTitle}</span>
				<i class="nc-icon-mini ui-1_pencil sma-js-form-title-edit sma-form-title-edit ml-2"></i>`,
							),
					)
					.append(
						$('<div class="top-right">').append(
							$(
								`<a class="top-right-button advanced-branching" href="#" data-toggle="tooltip" title="${
									gettext('Branching Editor')
								}"><i class="nc-icon-outline arrows-2_split-round"></i></a>`,
							),

							$(
								`<span class="languages d-inline-block" data-toggle="tooltip" title="${
									gettext('Editing Language')
								}"></span>`,
							).append(this.languageSelector.$el.addClass('btn-group')),

							this.buildPageButtons(),

							$('<span class="page d-inline-block"></span>').append(
								this.buildPageSelect(),
							),
						),
					),
			)
			.append(this.pages);

		const footer = $('<div class="sma-button-footer fixed-bottom banner-offset"></div>');

		const footerLeft = $('<div class="sma-button-footer-left"></div>').append(
			this.previewButton,
		);
		footer.append(footerLeft);

		const footerCenter = $('<div class="sma-button-footer-center"></div>').append(
			$('<a></a>', {
				class: 'btn btn-default btn-loud',
				id: 'sma-btn-cancel',
				href: '#',
				html: gettext('Cancel'),
				click(e) {
					e.preventDefault();
					if (that.closeWindow) {
						window.close();
					}
					window.history.back();
				},
			}),

			// Save button
			$('<a></a>', {
				class: 'save-top-link btn btn-primary btn-loud',
				id: 'sma-btn-save',
				href: '#',
				html: gettext('Save'),
				click(e) {
					e.preventDefault();
					that.save();
					that.survey.editor.pageStatusView.render();
				},
			}),

			// Save and close button
			$('<a></a>', {
				class: 'save-top-link btn btn-primary btn-loud',
				id: 'sma-btn-save-close',
				href: '#',
				html: gettext('Save & close'),
				click(e) {
					e.preventDefault();
					that.save(() => {
						if (that.closeWindow) {
							window.close();
						}
						if (that.backURL !== undefined) {
							window.location.href = that.backURL;
						} else {
							window.history.back();
						}
					});
				},
			}),
		);
		footer.append(footerCenter);

		const footerRight = $('<div class="sma-button-footer-right"></div>');
		footer.append(footerRight);

		this.viewport.append(footer);

		this.viewport.on('click', '.advanced-branching', (e) => {
			e.preventDefault();
			that.survey.currentPage.showBranchingWizard();
			return false;
		});

		$(that.survey.title._input).hide();

		this.viewport.on('click', '.sma-js-form-title-edit', () => {
			$(that.survey.title._input).show();
			$(that.survey.title._input).focus();
			$('.sma-js-form-title').hide();
			$('.sma-js-form-title-edit').hide();
		});

		$(that.survey.title._input).keypress((e) => {
			if (e.which != 13) {
				return;
			}
			$(that.survey.title._input).hide();
			$('.sma-js-form-title').show();
			$('.sma-js-form-title-edit').show();
		});

		$(that.survey.title._input).blur(() => {
			$(that.survey.title._input).hide();
			$('.sma-js-form-title').show();
			$('.sma-js-form-title-edit').show();
		});

		this.viewport.on('click', '.sma-js-form-description-edit', () => {
			$(that.survey.description._input).show();
			$(that.survey.description._input).focus();
			$('.sma-js-form-description-edit-done').show();
			$('.sma-js-form-description').hide();
			$('.sma-js-form-description-edit').hide();
		});

		this.viewport.on('click', '.sma-js-form-description-edit-done', () => {
			$(that.survey.description._input).hide();
			$('.sma-js-form-description-edit-done').hide();
			$('.sma-js-form-description').show();
			$('.sma-js-form-description-edit').show();
		});

		this.topRow.append($('<div class="col-8"></div>').append(this.viewport));

		if (!this.pages.length) {
			this.survey.addEmptyPage();
		}

		this.survey.switchPage(0);
	},

	buildPageSelect() {
		const that = this;
		const { survey } = this;

		const refresh = function (e, val) {
			pageSelect.empty();

			$.each(survey.pages, function (i, page) {
				let current;

				if (this.survey.currentPage !== undefined) {
					current = this.survey.currentPage.index;
				} else {
					current = val ? val !== undefined : 0;
				}

				const opt = $('<option>', {
					text: page.label.display(),
					value: i,
				});

				if (current == i) {
					opt.attr('selected', 'selected');
				}

				opt.appendTo(pageSelect);

				$.each(page.fields, (i, field) => {
					const title = field.name.get()
						? `[${
							field.name.get()
						}] ${
							$('<div></div>', { html: field.title.get() }).text()}`
						: $('<div></div>', { html: field.title.get() }).text();
					const label = `&nbsp;&nbsp;&nbsp;&#8627;&nbsp;${
						title.length > 40 ? `${title.substring(0, 35)}...` : title}`;
					const inner = $('<option>', {
						disabled: true,
						html: label,
						value: field.id,
					});
					inner.appendTo(pageSelect);
				});
			});

			if (survey.pages.length == 1) {
				that.removePageButton.hide();
			} else {
				that.removePageButton.show();
			}
		};

		var pageSelect = $('<select></select>')
			.addClass('form-control')
			.bind('focus', function (e) {
				const val = $(this).val();
				refresh(e, val);
			})
			.change(function () {
				survey.switchPage($(this).val());
			});

		refresh();

		survey.element.bind({
			'pageAdded pageRemoved afterPageRemoved': refresh,
			pageLabelChanged(e, page, label) {
				$('option:selected', pageSelect).text(label.display());
			},
			pageSwitched(e, info) {
				if (info.pageMove) {
					refresh();
				}
				pageSelect.val(info.index);
			},
		});

		return pageSelect;
	},

	buildPageButtons() {
		const that = this;

		this.addPageButton = $('<a></a>', {
			href: '#',
			text: gettext('Add'),
			title: gettext('Add new page'),
			'data-toggle': 'tooltip',
			html: '<i class="nc-icon-mini ui-1_bold-add"></li>',
			click(e) {
				e.preventDefault();
				that.survey.addEmptyPage();
			},
		});

		this.removePageButton = $('<a></a>', {
			href: '#',
			text: gettext('Remove'),
			title: gettext('Delete current page'),
			'data-toggle': 'tooltip',
			html: '<i class="nc-icon-mini ui-1_trash-simple"></li>',
			click(e) {
				e.preventDefault();
				that.survey.removePage();
			},
		});

		return $('<span></span>', { class: 'd-inline-block page-buttons' }).append(
			this.addPageButton,
			this.removePageButton,
		);
	},

	getPages() {
		return $('ol.page', this.pages);
	},

	escapeHtml(unsafe) {
		return unsafe
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;')
			.replace(/'/g, '&#039;');
	},

	initializeLanguages() {
		const that = this;

		const available_languages = [];
		let current_language = {};
		let langItem = {};

		for (const lang of window.__LANGUAGES) {
			langItem = {
				code: lang[0],
				name: lang[1],
			};
			available_languages.push(langItem);

			if (langItem.code === window.__LANGUAGE) {
				current_language = langItem;
			}
		}

		this.languages = {
			current: current_language,
			available: available_languages,
		};

		this.languages.displayStyle = '';
		this.languages.list = this.languages.available;

		const languageSelector = (this.languageSelector = $('<select></select>'));

		languageSelector.addClass('form-control');

		this.languages.add = function (c, n, d) {
			if (
				$.grep(that.languages.list, (el) => el.code === c).length === 0
			) {
				that.languages.list.push({
					code: c,
					name: n,
					isDefault: !!d,
				});
				const lang = languageSelector.val();
				languageSelector.addOption(c, n, false);
				languageSelector.sortOptions();
				languageSelector.val(lang);
			}
		};

		this.languages.selected = function () {
			return that.languages.current.code;
		};

		this.languages.defaultLanguage = function (c) {
			if (c !== undefined) {
				$.map(that.languages.list, (el) => {
					el.isDefault = el.code == c;
				});
				if (
					$.grep(that.languages.list, (el) => el.isDefault === true).length === 0
				) {
					that.languages.list[0].isDefault = true;
				}
			} else {
				let defaul = $.grep(that.languages.list, (el) => el.isDefault)[0];
				if (!defaul) {
					defaul = that.languages.list[0];
				}
				return defaul;
			}
		};

		this.languages.switchTo = function (lang) {
			that.languages.current = lang;

			_.each(that.survey.pages, (el) => {
				el.rendered = false;
			});
			if (that.survey.currentPage !== undefined) {
				that.survey.currentPage.render();
			}
			that.survey.render();

			that.fieldsSelected($('ol.page li.field.active'), undefined, true);

			that.refreshPreviewLink();

			if (['ar', 'fa', 'he'].indexOf(that.languages.selected()) != -1) {
				$('#survey-editor .pages').addClass('rtl');
			} else {
				$('#survey-editor .pages').removeClass('rtl');
			}
		};

		this.languages.translate = function (obj, code) {
			if (typeof obj === 'string') {
				return obj;
			}
			if (typeof obj === 'object') {
				if (obj[code] && obj[code].length) {
					return obj[code];
				}
				if (obj[that.languages.selected()] !== undefined) {
					return obj[that.languages.selected()];
				}
				if (obj[that.languages.defaultLanguage().code] !== undefined) {
					return obj[that.languages.defaultLanguage().code];
				}
				if (obj[0] !== undefined) {
					return obj[0];
				}
				if (obj.en) {
					return obj.en;
				}
				return '';
			}
		};
		this.languages.objectify = function (obj) {
			if (typeof obj === 'string') {
				const out = { en: obj };

				$.map(that.languages.list, (el) => {
					out[el.code] = obj;
				});

				return out;
			}
			return obj;
		};

		const items = [];

		this.languages.available.forEach((lang) => {
			items.push({
				name: lang.code,
				text: lang.name,
				action(_obj) {
					that.languages.switchTo(lang);
					this.changeTitle(
						`<i class="nc-icon-mini business_globe"></i> ${
							lang.code.toUpperCase()}`,
					);
				},
			});
		});

		this.languageSelector = new Dropdown({
			title: `<i class="nc-icon-mini business_globe"></i> ${
				this.languages.current.code.toUpperCase()}`,
			noCaret: true,
			rightAligned: true,
			items,
		});
	},

	renderFieldTypes() {
		const tools = $('<div></div>');

		const fields = $('<ul class="tools clearfix"></ul>');

		const advancedFields = $('<ul class="tools clearfix"></ul>').css(
			'display',
			'none',
		);

		$.each(this.fieldTypes, (qlass, field) => {
			if (field.isVisible && ((field.isQuestion && !field.isCustom)
				|| field.type == 'section-separator')) {
				$('<li></li>')
					.attr('field-type', qlass)
					.addClass(['tool', qlass].join(' '))
					.attr(
						'title',
						field.helpText ? `${field.displayName} - ${field.helpText}` : '',
					)
					.tooltip({
						showURL: false,
						fade: 250,
						delay: 0,
						track: true,
						showBody: '-',
					})
					.html(
						`<span class="${
							qlass
						}-text">${
							gettext(field.displayName)
						}</span>`,
					)
					.appendTo(fields);
			} else if (field.isVisible) {
				$('<li></li>')
					.attr('field-type', qlass)
					.addClass(['tool', qlass].join(' '))
					.attr(
						'title',
						field.helpText ? `${field.displayName} - ${field.helpText}` : '',
					)
					.tooltip({
						showURL: false,
						fade: 250,
						delay: 0,
						track: true,
						showBody: '-',
					})
					.html(
						`<span class="${
							qlass
						}-text">${
							gettext(field.displayName)
						}</span>`,
					)
					.appendTo(advancedFields);
			}
		});

		if (!fields.children('li').length || !advancedFields.children('li').length) {
			tools.append(fields, advancedFields);
		} else {
			if (fields.length) {
				tools.append(
					$('<div class="questiongroup"></div>')
						.append(
							$('<h3>').append(
								$(
									`<a class="expanded" href="#">${
										gettext('Basic Question Types')
									}</a>`,
								).click(function () {
									$(this).toggleClass('expanded');
									fields.toggle();
									return false;
								}),
							),
						)
						.append(fields),
				);
			}
			if (advancedFields.length) {
				tools.append(
					$('<div class="questiongroup"></div>')
						.append(
							$('<h3>').append(
								$(
									`<a href="#">${gettext('Advanced Question Types')}</a>`,
								).click(function () {
									$(this).toggleClass('expanded');
									advancedFields.toggle();
									return false;
								}),
							),
						)
						.append(advancedFields),
				);
			}
		}
		return tools;
	},

	initializeToolbox() {
		const that = this;

		this.toolbox = $('<div class="toolbox"></div>');

		this.tabs = $(`
	  <ul class="sma-submenu-container" role="tablist">
		<li class="nav-item">
		  <a class="nav-link active sma-submenu-item" data-toggle="tab" href="#survey-editor-fields" aria-control="survey-editor-fields">
			${gettext('Questions')}
		  </a>
		</li>
		<li class="nav-item">
		  <a class="nav-link sma-submenu-item" data-toggle="tab" href="#survey-editor-branching" aria-control="survey-editor-branching">
			${gettext('Page')}
		  </a>
		</li>
		<li class="nav-item">
		  <a class="nav-link sma-submenu-item" data-toggle="tab" href="#survey-editor-field-options-tab" aria-control="survey-editor-field-options-tab">
			${gettext('Options')}
		  </a>
		</li>
	  </ul>`).appendTo(this.toolbox);

		this.panels = $('<div class="panels clearfix"></div>');

		this.tools = this.renderFieldTypes();

		const $allQuestions = $('li.tool', this.tools);
		const $draggableQuestions = $allQuestions.filter(
			':not(.sma-js-non-draggable)',
		);
		const $nonDraggableQuestions = $allQuestions.filter('.sma-js-non-draggable');

		$nonDraggableQuestions.draggable({
			drag(_e, _ui) {
				new sma.components.Alert({
					message: gettext(
						'This question cannot be used directly. Please click on it to expand and use the sub-questions.',
					),
					type: 'warning',
				});
				return false;
			},
		});

		$draggableQuestions
			.draggable({
				helper: 'clone',
				revert: 'invalid',
				connectToSortable: `#${that.element.attr('id')} div.pages ol.page`,
				start(e) {
					$(e.target)
						.parent()
						.find('li:not(:last-child)')
						.css('opacity', 0.2);
					$(e.target)
						.parent()
						.parent()
						.siblings()
						.css('opacity', 0.2);
					$(e.target)
						.parent()
						.parent()
						.parent()
						.find('h3')
						.css('opacity', 0.2);
				},
				stop(e) {
					$('li.tool').css('opacity', 1);
					$(e.target)
						.parent()
						.parent()
						.parent()
						.find('h3')
						.css('opacity', 1);
					$(e.target)
						.parent()
						.parent()
						.siblings()
						.css('opacity', 1);
				},
			})
			.click(function () {
				$('li.tool', this.tools).removeClass('selected');
				$(this).addClass('selected');
			})
			.dblclick(function () {
				that.addField($(this).attr('field-type'));
				if ($('ol.page.active li.field').length === 0) {
					$('ol.page.active li.placeholder').show();
				} else {
					$('ol.page.active li.placeholder').hide();
				}
			});

		const subtools = $('<div></div>');
		this.tools.appendTo(subtools);

		subtools.appendTo(
			$(
				'<div id="survey-editor-fields" class="field-type-list panel clearfix"></div>',
			).appendTo(this.panels),
		);

		// Question Options Tab
		$(
			'<div id="survey-editor-field-options-tab" class="panel clearfix">'
			+ '<div class="property-group" id="survey-editor-field-options"></div>',
		).appendTo(this.panels);

		$('#survey-editor-field-options').html(this.emptyFieldOptionContent);

		// Page Options Tab
		$('<div id="survey-editor-branching" class="panel clearfix"></div>')
			.append(
				'<div class="property-group" id="survey-editor-page-options"></div>',
			)
			.appendTo(this.panels);

		this.toolbox.append(this.tabs).append(this.panels);

		this.topRow.append($('<div class="col-4"></div>').append(this.toolbox));

		this.toolbox.tabs({
			hideClass: 'hidden',
			selectedClass: 'active',
			select(e, ui) {
				return that.tabActivated(e, ui);
			},
			show(e, ui) {
				return that.tabShown(e, ui);
			},
		});

		$('.sma-js-parent').click((e) => {
			const target = $(e.currentTarget);
			const fieldType = target.attr('field-type');
			const shouldItOpen = target.hasClass('sma-collapsed');
			target.toggleClass('sma-collapsed');

			target.nextAll().each((i, el) => {
				const $el = $(el);
				const parentFieldType = $el.data('parent') || '';

				// stop the moment which hit a non descendant
				if (!parentFieldType.includes(fieldType)) {
					return false;
				}

				// if it's a direct child expand it
				if (shouldItOpen) {
					if (fieldType == parentFieldType) {
						$el.removeClass('sma-child-collapsed');
					}
				} else {
					$el.addClass('sma-child-collapsed');
					if ($el.hasClass('sma-js-parent')) {
						$el.addClass('sma-collapsed');
					}
				}
			});
		});
	},

	/* activates the passed tab by highlighting it and switching to the appropriate panel */
	tabActivated(e, ui) {
		const that = this;
		$('li.tool', that.tools).removeClass('selected');
		if (ui.tab.hash == '#survey-editor-survey-options') {
			$('ol.page li.field', this.pages).each((i, el) => {
				if ($(el).attr('name') == 'javascript') {
					$(el)
						.children('form')
						.hide();
					if (
						that.survey.getFieldArray($(el))[0].javascripter
						&& that.survey.getFieldArray($(el))[0].javascripter.builder_dialog
					) {
						that.survey
							.getFieldArray($(el))[0]
							.javascripter.builder_dialog.dialog('destroy');
						that.survey.getFieldArray(
							$(el),
						)[0].javascripter.builder_dialog = null;
					}
				}
				$(el).removeClass('active');
			});
		}
	},

	/* called after a tab is shown */
	tabShown() {
		/* if (ui.tab.hash == '#survey-editor-survey-options') {
		 * } */
	},

	onFieldSelected(field) {
		const delta = field.element.position().top + 120;

		this.toolbox.fadeOut(100, () => {
			this.toolbox
				.css('margin-top', field.element.position().top + 120)
				.fadeIn(100, () => {
					if (delta + this.toolbox.height() > this.viewport.height()) {
						this.toolbox[0].scrollIntoView();
					}
				});
		});
	},

	/* fields were selected, so show the correct options */
	fieldsSelected(fields, e, forceRefresh) {
		// TODO: make this take a list of either field objects, field elements, or field ids
		const page = this.survey.editor.currentPage;
		const pageEl = page === undefined ? $('ol.page.active') : page.element;
		const allFields = $('li.field', pageEl);
		const oldFields = this.survey.getFieldArray(allFields.filter('.active'));

		// Remove All indications that something was selected
		allFields.removeClass('active').removeClass('ui-selected');
		$('.sma-js-field-actions').show();
		$('.sma-js-field-num').remove();

		if (
			allFields.length === 0
			|| (this.survey.currentPage && this.survey.currentPage.fields.length === 0)
		) {
			$('li.placeholder', pageEl).show();
		} else {
			$('li.placeholder', pageEl).hide();
		}

		fields = this.survey.getFieldArray(fields);

		if (e !== undefined && e.shiftKey) {
			const fieldsToAdd = [];
			for (const field of fields) {
				if (oldFields.indexOf(field) > -1) {
					oldFields.splice(oldFields.indexOf(field), 1);
				} else {
					fieldsToAdd.push(field);
				}
			}
			fields = oldFields.concat(fieldsToAdd);
		}

		if (oldFields.length === 1
			&& oldFields[0].type == 'javascript'
			&& oldFields[0] !== fields[0]) {
			oldFields[0].element.children('form').hide();
			if (oldFields[0].javascripter.builder_dialog) {
				oldFields[0].javascripter.builder_dialog.dialog('destroy');
				oldFields[0].javascripter.builder_dialog = null;
			}
		}

		if (!fields.length || fields.length <= 0) {
			// With React types, we need to clear taking into account a potential React DOM
			const element = $('#survey-editor-field-options');
			ReactDOM.unmountComponentAtNode(element[0]);
			element.empty();
			element.html(this.emptyFieldOptionContent);

			// Set Question tab as active
			this.toolbox.tabs('option', 'active', 0);
			$(this.toolbox.find('.sma-submenu-item').removeClass('active')[0]).addClass('active');
			return;
		}

		this.onFieldSelected(fields[0]);

		for (let i = 0; i < fields.length; i++) {
			fields[i].element.addClass('ui-selected').addClass('active');
			if (i > 0) {
				fields[i].element.find('.sma-js-field-actions').hide();
			} else if (fields.length > 1) {
				fields[i].element
					.find('.sma-js-field-actions')
					.before(
						`<small class="sma-js-field-num selected-num">${
							fields.length
						} ${
							gettext('selected')
						}</small>`,
					);
			}
		}

		const active_tab = $('.sma-submenu-container a.active', this.toolbox).attr(
			'href',
		);

		if (
			active_tab !== '#survey-editor-field-options-tab'
			&& active_tab !== '#survey-editor-branching'
		) {
			this.toolbox.tabs('option', 'active', 2);
			$(
				this.toolbox.find('.sma-submenu-item').removeClass('active')[2],
			).addClass('active');
		}
		if (
			!forceRefresh
			&& fields.length === 1
			&& oldFields.length === 1
			&& this.survey.getFieldArray(oldFields)[0] === fields[0]
		) {
			return;
		}

		if (fields.length == 1) {
			fields[0].showOptions($('#survey-editor-field-options'));
			if (fields[0].type == 'javascript') {
				fields[0].javascripter.update_piper(
					this.survey,
					fields[0].globalpiper.value,
					fields[0].noids.value,
				);
				fields[0].element.children('form').show();
			}
		} else {
			$('#survey-editor-field-options').html(this.multipleFieldOptionContent);
		}

		this.toolbox.tabs('option', 'active', 2);
		$(this.toolbox.find('.sma-submenu-item').removeClass('active')[2]).addClass(
			'active',
		);
	},

	removeField(field, e) {
		if (e) {
			e.preventDefault();
		}

		Fields.Actions.del_field.handler(field, e);
	},

	duplicateField(field, e) {
		if (e) {
			e.preventDefault();
		}

		Fields.Actions.duplicate.handler(field, e);
	},

	moveField(field, e) {
		if (e) {
			e.preventDefault();
		}

		Fields.Actions.move_field.handler(field, e);
	},

	openLooping(field, e) {
		if (e) {
			e.preventDefault();
		}

		Fields.Actions.looping.handler(field, e);
	},

	addField(type, info, page, pos, e) {
		if (e) {
			e.preventDefault();
		}

		if (page === undefined) {
			page = this.survey.currentPage;
		}

		return page.addField(type, info, pos);
	},

	beforeAddPage() {
		return true;
	},

	pageSwitched(e, info) {
		const that = this;
		const allPages = $('ol.page');
		const { page } = info;
		const pageEl = info.page.element;

		if (page.fields.length > 0) {
			$('li.placeholder', pageEl).hide();
		} else {
			$('li.placeholder', pageEl).show();
		}

		try {
			allPages.sortable('destroy');
		} catch (e) {
			// eslint-disable-line
		}

		try {
			allPages.selectable('destroy');
		} catch (e) {
			// eslint-disable-line
		}

		ReactDOM.unmountComponentAtNode($('#survey-editor-field-options')[0]);
		$('#survey-editor-field-options').empty();
		$('#survey-editor-field-options').html(this.emptyFieldOptionContent);

		$('ol.page li.field.active', this.pages).each((i, el) => {
			if ($(el).attr('name') == 'javascript') {
				$(el)
					.children('form')
					.hide();
				if (that.survey.getFieldArray($(el))[0].javascripter.builder_dialog) {
					that.survey
						.getFieldArray($(el))[0]
						.javascripter.builder_dialog.dialog('destroy');
					that.survey.getFieldArray(
						$(el),
					)[0].javascripter.builder_dialog = null;
				}
			}
			$(el).removeClass('active');
		});

		page._branchingSelect = undefined;

		$('#survey-editor-page-options')
			.empty()
			.append(page.renderOptions().attr('id', 'survey-editor-page-options'));

		setTimeout(() => {
			if (that.toolbox.tabs('option', 'selected') !== 1) {
				that.toolbox.tabs('option', 'active', 0);
				$(
					that.toolbox.find('.sma-submenu-item').removeClass('active')[0],
				).addClass('active');
			}
		}, 0);

		this.refreshPreviewLink();

		this.pageStatusView.render();

		if (this.viewport) {
			if (
				this.element.offset().top
				+ this.element.height()
				- this.viewport.offset().top
				- this.viewport.height()
				> 20
			) {
				$(window).scrollTop(
					this.viewport.offset().top
					+ this.viewport.height()
					- $(window).height(),
				);
			} else {
				$(window).scroll();
			}
		}

		$('ol.page.active', this.pages).sortable({
			axis: 'y',
			revert: false,
			dropOnEmpty: true,
			cursor: 'pointer',
			tolerance: 'pointer',
			distance: 5,
			items: '> .field',
			cancel: '.field:not(.active),#scriptform',
			placeholder: 'field ui-sortable-placeholder',
			over(e, ui) {
				ui.item.addClass('field-sorting');
			},
			sort() {
				$('.page.active').selectable('disable');
			},
			stop(_e, ui) {
				$('.page.active').selectable('enable');
				$(this).sortable('refresh');
				$(this).selectable('refresh');
				ui.item.removeClass('field-sorting');
			},
			deactivate() {
				$('body').css('cursor', 'default');
			},
			out() {
				$(this).removeClass('ui-selectable-disabled ui-state-disabled');
			},
			receive(e, ui) {
				if ($(e.target).hasClass('active')) {
					if (ui.item.hasClass('tool')) {
						const tool = $('> li.tool', this);

						const pos = $(this)
							.find('> li.field:not(.ui-sortable-placeholder), > li.tool')
							.index(tool);
						const temp = that.addField(
							ui.item.attr('field-type'),
							undefined,
							undefined,
							pos - 1,
						);

						tool.remove();

						try {
							that.fieldsSelected(temp.element, {});
						} catch (e) {
							// eslint-disable-line
						}
					}
				}

				$(this).sortable('refresh');
			},
		});

		try {
			$('ol.page').selectable('destroy');
		} catch (e) {
			// eslint-disable-line
		}

		$('ol.page.active').selectable({
			distance: 5,
			filter: 'li.field',
			cancel: 'li.field.active',
			autoRefresh: true,
			selected(e, ui) {
				$(ui.selected).addClass('active');
			},
			selecting(e, ui) {
				$(ui.selecting).addClass('active');
			},
			unselected(e, ui) {
				$(ui.unselected).removeClass('active');
			},
			unselecting(e, ui) {
				if ($(ui.target).hasClass('remove')) {
					$(ui.unselecting)
						.removeClass('ui-unselecting')
						.addClass('ui-selected');
					return;
				}
				$(ui.unselecting).removeClass('active');
			},
			stop(e) {
				that.fieldsSelected(
					$('ol.page.active .field.ui-selected').removeClass('active'),
					e,
				);
			},
		});

		this.toolbox.css('margin-top', 0);
	},

	refreshPreviewLink() {
		if (this.previewButton === undefined) return;
		if (this.survey.currentPage) {
			const { index } = this.survey.currentPage;
			this.previewButton.attr(
				'href',
				`${reverse('surveys-preview', { survey_id: this.surveyID })
				}?preview=1&lang=${
					this.languages.selected()
				}${index !== 0 ? `&_previewpage=${index}` : ''
				}&TEST_DATA`,
			);
		}
	},

	/** ********************
	 * Loading and Saving *
	 ********************* */

	load(callback) {
		const that = this;

		// this.drafting = new Drafting(this);

		$.ajax({
			type: 'get',
			url: `${reverse('surveys-versions', { survey_id: this.surveyID })
			}?c=${
				randomString(20)}`,
			success(data) {
				if (data.versions.length > 0) {
					that.currentrevision = parseInt(
						data.versions[0].revision.substring(1),
					);
				} else {
					that.currentrevision = 0;
				}
			},
		});

		that.languages.list = [{
			code: this.languages.current.code,
			name: this.languages.current.name,
			isDefault: true,
		}];
		that.languages.displayStyle = 'dropdown';

		const handleSurveyData = function (data) {
			if (!data.data) {
				that.survey.addEmptyPage();
				callback();
				return;
			}

			that.form_is_live = data.form_is_live;

			if (data.form_is_live) {
				$('#survey-editor .sma-back-row').before(
					'<div class="row mb-2"><div class="col-md-12"><div id="sma-formlive-callout-container"></div>',
				);

				const markup = gettext(
					'<strong>Warning: It appears that this form has live data</strong>. Making changes to the form after collecting data is strongly discouraged as it could harm the integrity of your data. Read more about editing live forms from our <a href="https://help.surveymonkey.com/en/apply/build/change-live-form/" target="_blank" class="sma-underline-blue-link">Help Center</a>.',
				);

				new Callout({
					attachTo: $('#sma-formlive-callout-container'),
					content: markup,
					callout_class: 'callout-warning',
				});
			}

			const survey = data.data;
			that.languages.list = [];
			$.map(
				that.languages.available || [{
					code: that.languages.current.code,
					name: that.languages.current.name,
					isDefault: true,
				}],
				(el) => {
					that.languages.add(el.code, el.name, el.isDefault);
				},
			);

			that.languageSelector.changeTitle(
				`<i class="nc-icon-mini business_globe"></i> ${
					(that.languages.current.code || that.languages.defaultLanguage().code).toUpperCase()}`,
			);

			that.languages.displayStyle = survey.languageDisplayStyle || 'dropdown';

			that.survey.load(survey);
			callback();
			that.survey.switchPage(0);
			// that.drafting.startPolling();
		};

		const draft = null; // this.drafting.get();

		if (draft != null) {
			handleSurveyData({ data: draft });
			// this.drafting.notifyLoaded();
		} else {
			$.ajax({
				type: 'get',
				url: `${reverse('surveys-datasource', { survey_id: this.surveyID })
				}?c=${
					randomString(20)}`,
				dataType: 'json',
				success: (data, _status) => {
					handleSurveyData(data);
				},
			});
		}
	},

	saveSuccess(callback, response) {
		const that = this;
		that.currentrevision = response.revision;

		new sma.components.Alert({
			message: gettext('Your form has been saved.'),
			type: 'success',
		});

		setTimeout(() => {
			this.loader.hide();
			callback(true);
		}, 1000);
	},

	saveError(callback, response) {
		const that = this;
		this.response_error = 'N/A';

		if (response.status === 0) {
			this.response_message = gettext(
				'An error has occured and your form was NOT saved. Make sure that you have an active internet connection and try saving your form again.',
			);
		} else if (response && response.message) {
			this.response_message = response.message;
			if (response.error) {
				this.response_error = response.error;
			}
		} else if (response && response.error) {
			this.response_message = gettext(
				'An error has occured and your form was NOT saved. If you continue having issues, contact customer support with the error details listed below.',
			);
			if (response.error && typeof response.error === 'string') {
				this.response_error = response.error;
			} else {
				this.response_error = response.statusText;
			}
		}

		if (response && response.versions) {
			that.changeToHistory(callback, response.versions);
		} else {
			var dialog = $('<div>')
				.append(
					$('<p>', { style: 'color:darkred;' }).html(this.response_message),
					$('<br />'),
					$('<p>').append(
						$('<br />'),
						$('<strong>', { text: gettext('Error Details:') }),
						$('<div>', { style: 'color:darkred;' }).html(this.response_error),
					),
				)
				.dialog({
					title: gettext('Error Saving Survey'),
					width: 500,
					height: 300,
					autoResize: true,
					zIndex: 30000,
					dialogClass: 'subscribermail',
					close() {
						dialog.dialog('destroy');
						callback(false);
					},
				})
				.dialog('option', 'buttons', [{
					class: 'icon icon-check',
					text: gettext('OK'),
					click() {
						dialog.dialog('close');
					},
				}]);
		}
	},

	changeToHistory(callback, versions) {
		const that = this;
		if (!callback) {
			callback = function () {
			};
		}
		this.revisions = {};
		this.revisions.versions = versions;

		that.revisions.selectBox = $('<select class="version"></select>');
		$.map(that.revisions.versions, (el) => {
			that.revisions.selectBox.append(
				`<option value="${
					el.id
				}">${
					el.revision
				}: ${
					el.label
				}</option>`,
			);
		});

		this.revisions.showDialog = function () {
			if (that.revisions.dialogDiv === undefined) {
				that.revisions.infoDiv = $('<div class="version"></div>');
				that.revisions.selectBox
					.unbind('change')
					.change(() => {
						const version = $.grep(that.revisions.versions, (el) => {
							if (that.revisions.selectBox.val() == el.id) {
								return el;
							}
						})[0];
						that.revisions.infoDiv.html(version.created_at);
					})
					.change();

				that.revisions.dialogDiv = $('<div></div>')
					.append(
						$(
							`<div class="versions"><div class="help">${
								gettext(
									'Newer revisions of this survey have been made since the survey was loaded or saved on this page. Newer revisions are listed below. Click on "View" to open a window which will display the state of your survey for the given version. Click "Load" to replace your current survey with the specified version. Click "Cancel" to cancel the current save. Click "Save" to save your modifications in a new revision.',
								)
							}</div></div>`,
						)
							.append(that.revisions.selectBox)
							.append(that.revisions.infoDiv),
					)
					.dialog({
						title: gettext('Warning'),
						width: 400,
						height: 300,
						zIndex: 30000,
						modal: true,
						bgiframe: true,
						close() {
							$(this).dialog('destroy');
						},
					})
					.dialog('option', 'buttons', [{
						class: 'icon icon-save',
						text: gettext('Save'),
						click() {
							$(this).dialog('destroy');
							that.save(that.callback, true);
						},
					},
					{
						class: 'icon icon-preview',
						text: gettext('View'),
						click() {
							const version = $.grep(that.revisions.versions, (el) => {
								if (that.revisions.selectBox.val() == el.id) {
									return el;
								}
							})[0];
							that.revisions.showVersion(version);
						},
					},
					{
						class: 'icon icon-upload',
						text: gettext('Load'),
						click() {
							const version = $.grep(that.revisions.versions, (el) => {
								if (that.revisions.selectBox.val() == el.id) {
									return el;
								}
							})[0];
							that.revisions.loadVersion(version);
							$(this).dialog('destroy');
						},
					},
					{
						class: 'icon icon-cancel',
						text: gettext('Cancel'),
						click() {
							$(this).dialog('destroy');
						},
					},
					]);
			} else {
				that.revisions.dialogDiv.dialog('open');
			}
		};
		this.revisions.loadVersion = function (version) {
			$.ajax({
				type: 'post',
				url: `${EDIT_URL + version.id}/?c=${randomString(20)}`,
				data: { action: 'revert' },
				success() {
					window.onbeforeunload = () => {
					};
					window.location.reload();
				},
			});
		};
		this.revisions.showVersion = function (version) {
			window.open(
				`${EDIT_URL + version.id}/`,
				`previous_version_${version.id}`,
				'width=980,height=500,toolbar=no,location=no,directories=no,status=no,menubar=no,copyhistory=no,scrollbars=yes',
			);
		};
		that.revisions.showDialog();
	},

	save(callback, force) {
		const that = this;
		const saveURL = `${reverse('surveys-save', { survey_id: this.surveyID })
		}?c=${
			randomString(20)}`;

		if (!ALLOW_SAVE) return;
		if (!callback) {
			callback = () => {
			};
		}
		if (!force) force = false;

		this.loader.show();

		const DO_SAVE = (data) => {
			that.hashedJson = hashCode(that.serialize().survey);

			$.ajax({
				type: 'post',
				url: saveURL,
				data: {
					survey: data,
					force: false,
					revision: that.currentrevision,
				},
				dataType: 'json',
				async: true,
				success(response) {
					that.saveSuccess(callback, response);
				},
				error(response) {
					that.saveError(callback, response);
				},
			});
		};

		const DO_SAVE_FORCE = (data) => {
			that.hashedJson = hashCode(that.serialize().survey);

			$.ajax({
				type: 'post',
				timeout: 30000,
				url: saveURL,
				data: {
					survey: data,
					force: true,
					revision: that.currentrevision,
				},
				dataType: 'json',
				async: true,
				success(response) {
					that.saveSuccess(callback, response);
				},
				error(response) {
					that.saveError(callback, response);
				},
			});
		};

		setTimeout(() => {
			try {
				var survey = that.serialize();
			} catch (e) {
				const response = {
					error: e,
					message: interpolate(
						gettext(
							'We\'re sorry, but an error occurred while serializing your survey.',
						),
						[gettext('Form')],
					),
				};
				that.saveError(() => {
				}, response);
				return;
			}

			that.embedded_script = !!survey.survey
				.toString()
				.match(/<script[^>]*>.*?<\/script>/gi);

			if (force) {
				DO_SAVE_FORCE(survey.survey, false);
			} else {
				DO_SAVE(survey.survey, false);
			}
		}, 50);

		return true;
	},

	serialize() {
		return { survey: JSON.stringify(this.survey.serialize()) };
	},
});

module.exports = {
	Editor,
	Survey,
};
